import _ from 'lodash'
import PT from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { WidgetFC, WidgetProps } from 'index.d'
import { LabelsPropType, WidgetMapPropType, WidgetPropType } from 'index.pt'
import WidgetDelete from './WidgetDelete'
import WidgetEdit from './WidgetEdit'

const WidgetPlaceholder = styled.div`
  position: relative;
`

const renderPlaceholders = (template: any, values: any) => {
  template = template.replace(/\{\{([^}]+)\}\}/g, (match: string) => {
    match = match.slice(2, -2)
    return values[match] || '{{' + match + '}}'
  })
  return template
}

const Widget: React.FC<WidgetProps> = (props: WidgetProps): JSX.Element => {
  const { labels, mode, myWidgets, widget } = props

  const FoundWidget: WidgetFC<WidgetProps> = _.find(_.values(myWidgets), (it: WidgetFC<WidgetProps>) => {
    return it.properties ? it.properties.type === widget.type : false
  })

  if (FoundWidget) {
    return (
      <WidgetPlaceholder>
        <FoundWidget {...props} />
        <WidgetEdit active={mode === 'edit'} {...props} />
        <WidgetDelete active={mode === 'delete'} {...props} />
      </WidgetPlaceholder>
    )
  }

  return <div>{renderPlaceholders(labels.noWidgetForType!, { type: widget.type })}</div>
}

Widget.propTypes = {
  labels: LabelsPropType.isRequired,
  mode: PT.string,
  myWidgets: WidgetMapPropType.isRequired,
  widget: WidgetPropType.isRequired
}

export default Widget
